// extracted by mini-css-extract-plugin
export default {"color-black":"#000000","colorBlack":"#000000","item":"_2XVJu _2AZKg _3cgKO","itemChecked":"L5mBf","label":"_3M0xm","icon":"Inmd3 _2cCom","iconChecked":"_2Qu98 _3NgFG"};